import { render, staticRenderFns } from "./processSetting.vue?vue&type=template&id=3006fc75&scoped=true"
import script from "./processSetting.vue?vue&type=script&lang=js"
export * from "./processSetting.vue?vue&type=script&lang=js"
import style0 from "./processSetting.vue?vue&type=style&index=0&id=3006fc75&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3006fc75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3006fc75')) {
      api.createRecord('3006fc75', component.options)
    } else {
      api.reload('3006fc75', component.options)
    }
    module.hot.accept("./processSetting.vue?vue&type=template&id=3006fc75&scoped=true", function () {
      api.rerender('3006fc75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/crud/components/processSetting.vue"
export default component.exports